import React from 'react';
import { ApolloProvider } from 'react-apollo';
import MLSMapPage from '../MLSMap/MLSMapPage';
import MLSMapProvider from '../../context/MLSMapContext';
import { client } from '../client';
import ErrorBoundary from '../ErrorBoundary';

function MLSMapContainer({ areas, placards }) {
  return (
    <ApolloProvider client={client}>
      <ErrorBoundary>
        <MLSMapProvider areas={areas} placards={placards}>
          <MLSMapPage areas={areas} />
        </MLSMapProvider>
      </ErrorBoundary>
    </ApolloProvider>
  );
}

export default MLSMapContainer;
